export default "__VITE_ASSET__rKKoyOoR__"